var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / symbols / instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3332 2.66675H10.6665C6.24823 2.66675 2.6665 6.24847 2.6665 10.6667V21.3334C2.6665 25.7517 6.24823 29.3334 10.6665 29.3334H21.3332C25.7514 29.3334 29.3332 25.7517 29.3332 21.3334V10.6667C29.3332 6.24847 25.7514 2.66675 21.3332 2.66675ZM5.33301 10.6668C5.33301 7.72131 7.72082 5.3335 10.6663 5.3335H21.333C24.2785 5.3335 26.6663 7.72131 26.6663 10.6668V21.3335C26.6663 24.279 24.2785 26.6668 21.333 26.6668H10.6663C7.72082 26.6668 5.33301 24.279 5.33301 21.3335V10.6668ZM15.9997 22.6668C12.3178 22.6668 9.33301 19.6821 9.33301 16.0002C9.33301 12.3183 12.3178 9.3335 15.9997 9.3335C19.6816 9.3335 22.6663 12.3183 22.6663 16.0002C22.6663 19.6821 19.6816 22.6668 15.9997 22.6668ZM16 20C18.2091 20 20 18.2091 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2091 13.7909 20 16 20ZM23.9997 9.33333C23.9997 10.0697 23.4027 10.6667 22.6663 10.6667C21.93 10.6667 21.333 10.0697 21.333 9.33333C21.333 8.59695 21.93 8 22.6663 8C23.4027 8 23.9997 8.59695 23.9997 9.33333Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4271a58409804c0f9831b4d5549388f9.svg";
export { ForwardRef as ReactComponent };